import React, { useEffect, useRef, useState } from 'react'
// import ReCAPTCHA from 'react-google-recaptcha'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import './HeartLand.scss'
import { Circles } from 'react-loader-spinner'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const DefaultComponent = () => <></>

// recapTchaKey is from sujan.123panda@gmail.com
// const captchaKey = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : '6LdCgFkpAAAAAAhwUYyPk7E1D5ASuMw9E9CX5EcW'
    let heartlandInitEpoch = 0

    
const PaymentGatwayHeartLand = ({
    paymentData, onSubmit, isSubmittingForm,
    consent, prevButton, formData,
    loginUser, LoginSignUpButton, previousButton,
    isCheckOutStatus, paymentDisable, page,
    setValue
}) => {
    // const recaptchaRef = useRef()
    const errorRef = useRef()
    const errorCard = useRef()
    const errorExp = useRef()
    const [btnLoader, setBtnLoader] = useState(false)
  
    // const onChange = (value) => {
    //   recaptchaRef.current.state = value
    // }
    useEffect(() => {
        if(window.Heartland) {
            paymentFunc()
        }
    }, [window?.Heartland])

    //    paymentFunc(`${(paymentData?.payable_amount && Number(paymentData?.payable_amount) > 0) ? Number(paymentData?.payable_amount).toFixed(2) : '0.00'}`)
    const paymentFunc = () => {
        heartlandInitEpoch += 1
        const myEpoch = heartlandInitEpoch

        new window.Heartland.HPS({
            publicKey: paymentData?.facility_payment_details?.heartland_public_api_key ? paymentData?.facility_payment_details?.heartland_public_api_key : '',
            type:      'iframe',
            secretKey: paymentData?.facility_payment_details?.heartland_secret_api_key ? paymentData?.facility_payment_details?.heartland_secret_api_key : '',
            // Configure the iframe fields to tell the library where
            // the iframe should be inserted into the DOM and some
            // basic options
            fields: {
            
                cardNumber: {
                    target:      'iframesCardNumber',
                    placeholder: 'Card Number',
                    value: ''
                    // value: ''
                },
                // cardHolderName: {
                //   target:      'iframesCardHolderName',
                //   placeholder: 'Name on Card',
                //   value: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '' : ''
                // },
                cardExpiration: {
                    target:      'iframesCardExpiration',
                    placeholder: 'MM / YYYY',
                    value: ''
                    // value: ''
                },
                cardCvv: {
                    target:      'iframesCardCvv',
                    placeholder: 'CVV',
                    value: '',
                    // value: ''
                    disabled: 'disabled'
                },
                submit: {
                    value: page == 'reservation' ? `Confirm and ${paymentDisable ? 'Book' : 'Pay'}` : page == 'addCard' ? 'Save Card' : 'Submit',
                    target:       'iframesSubmit',
                    disabled: true
                }
            },
            // Collection of CSS to inject into the iframes.
            // These properties can match the site's styles
            // to create a seamless experience.
            style: {
                'input': {
                    'background': '#fff',
                    'border': '1px solid',
                    'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
                    'box-sizing': 'border-box',
                    'font-family': 'serif',
                    'font-size': '0.85rem',
                    'line-height': '1',
                    'margin': '0 .5em 0 0',
                    'max-width': '100%',
                    'outline': '0',
                    'padding': '0.5278em',
                    'vertical-align': 'baseline',
                    'height' : '36px',
                    'width' : '100% !important'
                },
                '#heartland-field': {
                    'font-family': 'sans-serif',
                    'box-sizing':'border-box',
                    'display': 'block',
                    'height': '36px',
                    'padding': '6px 12px',
                    'font-size': '0.85rem',
                    'line-height': '1.42857143',
                    'color': '#212529',
                    'background-color': '#fff',
                    'border': '1px solid #ced4da',
                    'border-radius': '0px',
                    // '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
                    // 'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
                    // '-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
                    // '-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
                    'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
                    'width' : '100%'
                },  
                '#heartland-field[name=submit]': {   
                    // 'background-color':'#202d5d',
                    'font-family': 'sans-serif',
                    'font-size': page == 'reservation' ? '0.80rem': '0.92rem',
                    'border-radius': '0px',
                    'text-transform':'capitalize',
                    'color':'#ffffff',
                    // 'font-weight': 'bold',
                    'border':'0px solid transparent',
                    'width' : '100% !important',
                    'height' : '37px !important',
                    'padding' : '0 0.375rem !important',
                    'margin' : '0px !important',
                    'background-color' : 'transparent !important',
                } ,
                '#heartland-field[name=submit]:focus': {   
                    'color':'#ffffff',
                    // 'background-color':'#202d5d',
                    'outline':'none'
                } , 
                // '#heartland-field[name=submit]:hover': {   
                //     'background-color':'#202d5d'
                // },          
                '#heartland-field-wrapper #heartland-field:focus' : {
                    'border':'1px solid #8997a5',
                    'outline':'none',
                    'box-shadow':'none',
                    'height':'36px'
                },
                'heartland-field-wrapper #heartland-field' : {
                    'height':'36px'
                },
                'heartland-field-wrapper #heartland-field[name=submit]' : {
                    'height' : '32px'
                },
                'input[type=submit]' : {
                    'box-sizing':'border-box',
                    'display': 'inline-block',
                    'padding': '6px 12px',
                    'margin-bottom': '0',
                    'font-size': '0.85rem',
                    // 'font-weight': '400',
                    'line-height': '1.42857143',
                    'text-align': 'center',
                    'white-space': 'nowrap',
                    'vertical-align': 'middle',
                    '-ms-touch-action': 'manipulation',
                    'touch-action': 'manipulation',
                    'cursor': 'pointer',
                    '-webkit-user-select': 'none',
                    '-moz-user-select': 'none',
                    '-ms-user-select': 'none',
                    'user-select': 'none',
                    'background-image': 'none',
                    'border': '1px solid transparent',
                    'border-radius': '0px',
                    'color': '#fff',
                    'background-color': '#202d5d',
                    'border-color': '#2e6da4'
                },
                '#heartland-field[placeholder]' :{
                    'letter-spacing':'0px'
                },
                '#heartland-field[name=cardCvv]' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
                    'background-size' :'auto 25px',
                    'border-radius': '0px',
                },
                'input#heartland-field[name=cardNumber]' : {
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 25px',
                    'border-radius': '0px',
                },
                'input#heartland-field[name=cardExpiration]' : {
                    'border-radius': '0px',
                },
                '#heartland-field.invalid.card-type-visa' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 28px',
                    'background-position-y':'-44px'
                },
                '#heartland-field.valid.card-type-visa' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
                    'background-size' :'auto 32px'
                },
                '#heartland-field.invalid.card-type-discover' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 32px',
                    'background-position-y' : '-44px'
                },
                '#heartland-field.valid.card-type-discover' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 32px',
                    'background-position-y' : '1px'
                },
                '#heartland-field.invalid.card-type-amex' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 77px',
                    'background-position-y':'-38px'
                },
                '#heartland-field.valid.card-type-amex' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
                    'background-size' :'auto 77px',
                    'background-position-y':'-1px'
                },
                '#heartland-field.invalid.card-type-mastercard' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
                    'background-size' :'auto 77px',
                    'background-position-y':'-38px'
                },
                '#heartland-field.valid.card-type-mastercard' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
                    'background-size' :'auto 77px',
                    'background-position-y':'-1px'
                },
                '#heartland-field.invalid.card-type-jcb' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
                    'background-size' :'auto 77px',
                    'background-position-y':'-38px'
                },
                '#heartland-field.valid.card-type-jcb' :{
                    'background':'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
                    'background-size' :'auto 77px',
                    'background-position-y':'-1px'
                },
                'input#heartland-field[name=cardNumber]::-ms-clear' : {
                    'display':'none'
                },
                'iframe' :{
                    'width': '100%'
                }
            },
            // Callback when a token is received from the service
            onTokenSuccess: function (resp) {
                if (myEpoch !== heartlandInitEpoch) return
                // console.log('Here is a single-use token: ' + resp.token_value)
                //   let newDT = new Date()
                //   let tokenDT = new Date(resp?.token_expire)
                // if(recaptchaRef.current.state === null) {
                //   console.log('Please select captcha')
                //   errorRef.current.innerHTML = '<span>Please select captcha</span>'
                // } else
                if(resp.exp_month.trim().length === 2 && resp.exp_year.trim().length === 4 && resp.card.number.trim().length === 16) {
                    // let finalPayload = resp
                    // finalPayload.price = amount
                    setBtnLoader(false)
                    if(errorRef.current) {
                        errorRef.current.innerHTML = '<span>&nbsp;</span>'
                    }
                    if(page == 'reservation') {
                        setValue('paymentToken', resp)
                        onSubmit()
                    } else if(page == 'addCard') {
                        onSubmit(resp)
                     } else {
                        let payload = { ...formData }
                        payload.paymentToken = resp
                        // setFormData(payload)
                        onSubmit(payload)
                    }
                    
                    
                } else {
                    setBtnLoader(false)
                    if(errorRef.current) {
                        errorRef.current.innerHTML = '<span>Please enter valid details</span>'
                    }
                }
            },
            // Callback when an error is received from the service
            onTokenError: function (resp) {
                if (myEpoch !== heartlandInitEpoch) return
                setBtnLoader(false)
                if(resp?.error?.param == 'card.number' && errorCard.current) {
                    errorCard.current.innerHTML = `<span>${resp.error.message}</span>`
                } else if(resp?.error?.param == 'card.exp_year' && errorExp.current) {
                    errorExp.current.innerHTML = `<span>${resp.error.message}</span>`
                } else {
                    if(errorRef.current) {
                        errorRef.current.innerHTML = `<span>${resp.error.message}</span>`
                    }
                }
                
            },
            // Callback when an event is fired within an iFrame
            onEvent: function (ev) {
                if(ev.type == 'keypress') {
                    if(errorRef.current) {
                        errorRef.current.innerHTML = ''
                    }
                    if(errorCard.current) {
                        errorCard.current.innerHTML = ''
                    }
                    if(errorExp.current) {
                        errorExp.current.innerHTML = ''
                    }
                }
                if(ev.type === 'click' && ev.source === 'submit') {
                    setBtnLoader(true)
                }
            }
        })
    }

    return (
        <div className='pt-1' style={{position: 'relative', width: '100%'}}>
            <div className={'form-wrapper'}>
                {page == 'reservation' ? <div id='iframes'>
                    <div id='ss-banner' />
                    
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardNumber' className='form-label'>Card Number <span className="text-danger"> *</span></label>
                        <div id='iframesCardNumber' style={{width: '100%'}} />
                        <div ref={errorCard} className='errorIframe'></div>
                    </div>
        
                    {/* <div className='form-row'>
                      <label htmlFor='iframesCardHolderName'>Name on Card:</label>
                      <div id='iframesCardHolderName' style={{width: '100%'}} />
                    </div> */}
                    
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardExpiration' className='form-label'>Expiry Date <span className="text-danger"> *</span></label>
                        <div id='iframesCardExpiration' />
                        <div ref={errorExp} className='errorIframe'></div>
                    </div>
        
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardCvv' className='form-label'>Card CVV <span className="text-danger"> *</span></label>
                        <div id='iframesCardCvv' />
                    </div>
        
                    {/* <br />
                    <div style={{width: '304px', margin: '0 auto 20px'}}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={captchaKey}
                            onChange={onChange}
                        />
                    </div> */}
                    {consent}
                    <div className='text-center'>
                        <div className='d-inline-block mr-2 align-middle'>
                            {prevButton}
                        </div>
                        <div className={`border-t gap-2 pt-3 flex items-center ${!loginUser ? 'justify-between' : 'justify-end'}`}>
                            {!loginUser ? LoginSignUpButton : ''}
                            <div className="clearfix flex gap-1 items-center justify-between">
                                {previousButton}
                                {((btnLoader || isSubmittingForm) && !isCheckOutStatus) ? <button
                                    className="btn btn-primary text-sm sm:block  "
                                    //s onClick={nextPage}
                                    type="submit"
                                    name="submit"
                                    disabled={true}
                                    style={{'width':'auto'}}
                                    >
                                    <div className='d-flex align-items-center justif-center gap-1 items-centerd'>
                                        <small>
                                        {paymentDisable
                                            ? 'Confirm & Book'
                                            : 'Confirm & Pay'}
                                        </small>
                                        <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        />
                                    </div>
                                </button> : null }
                                <div className={(btnLoader || isSubmittingForm) ? 'd-none' : '' }><div id='iframesSubmit' className='btn btn-primary d-flex step-btn p-0 reservation' /></div>
                            </div>
                        </div>
                        <div ref={errorRef} className='errorIframe'></div>
                    </div>
                </div> : <form id='iframes' action='' method='GET'>
                    <div id='ss-banner' />
                    
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardNumber' className='form-label'>Card Number <span className="text-danger"> *</span></label>
                        <div id='iframesCardNumber' style={{width: '100%'}} />
                        <div ref={errorCard} className='errorIframe'></div>
                    </div>
        
                    {/* <div className='form-row'>
                      <label htmlFor='iframesCardHolderName'>Name on Card:</label>
                      <div id='iframesCardHolderName' style={{width: '100%'}} />
                    </div> */}
                    
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardExpiration' className='form-label'>Expiry Date <span className="text-danger"> *</span></label>
                        <div id='iframesCardExpiration' />
                        <div ref={errorExp} className='errorIframe'></div>
                    </div>
        
                    <div className='form-row mb-2'>
                        <label htmlFor='iframesCardCvv' className='form-label'>Card CVV <span className="text-danger"> *</span></label>
                        <div id='iframesCardCvv' />
                    </div>
        
                    {/* <br />
                    <div style={{width: '304px', margin: '0 auto 20px'}}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={captchaKey}
                            onChange={onChange}
                        />
                    </div> */}
                    {consent}
                    <div className='text-center'>
                        <div className='d-inline-block me-2 align-middle pb-3 mt-1'>
                            {previousButton}
                        </div>
                        <div className='d-inline-block align-middle mt-1 pb-3'>
                            {(btnLoader || isSubmittingForm) ? <button type="submit" className="btn btn-primary d-flex step-btn" style={{ color: 'white', opacity: (btnLoader || isSubmittingForm) ? '0.8' : '1' }} >
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <span>{page == 'addCard' ? 'Save Card' : page == 'reservation' ? 'Confirm & Book' : 'Submit'} </span>  <span className='ms-2'>
                                        {(btnLoader || isSubmittingForm) ? <Circles
                                            height="18"
                                            width="18"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                        </span>
                                    </div>
                                </button> : null }
                            <div className={(btnLoader || isSubmittingForm) ? 'd-none' : '' }><div id='iframesSubmit' className="btn btn-primary d-flex step-btn p-0" /></div>
                        </div>
                        <div ref={errorRef} className='errorIframe'></div>
                    </div>
                </form> }
            </div>
        </div>
    )
}


PaymentGatwayHeartLand.propTypes = {
    paymentData: PropTypes.object,
    onSubmit: PropTypes.func,
    isSubmittingForm: PropTypes.bool,
    amount: PropTypes.number,
    trigger: PropTypes.func,
    consent: PropTypes.elementType,
    prevButton: PropTypes.elementType,
    setFormData: PropTypes.func,
    formData: PropTypes.object,
    loginUser: PropTypes.bool,
    isCheckOutStatus: PropTypes.bool,
    paymentDisable: PropTypes.bool,
    LoginSignUpButton: PropTypes.elementType,
    previousButton: PropTypes.elementType,
    confirmPay: PropTypes.elementType,
    page: PropTypes.string,
    setValue: PropTypes.func,
}

PaymentGatwayHeartLand.defaulProps = {
    paymentData: EMPTY_OBJECT,
    onSubmit: noop,
    isSubmittingForm: false,
    amount: 0,
    trigger: noop,
    consent: DefaultComponent,
    prevButton: DefaultComponent,
    setFormData: noop,
    formData: EMPTY_OBJECT,
    loginUser: false,
    isCheckOutStatus: false,
    paymentDisable: false,
    LoginSignUpButton: DefaultComponent,
    previousButton: DefaultComponent,
    confirmPay: DefaultComponent,
    page: '',
    setValue: noop
}


export default PaymentGatwayHeartLand
